import { useContext } from "react";

import { EnumLabelsContext } from "./EnumLabelsContext";

export function useEnumLabels() {
  const context = useContext(EnumLabelsContext);
  if (!context) {
    throw new Error("useEnumLabels must be used within an EnumLabelsProvider");
  }
  return context;
}
